/*
 * Note: Code copied and adapted to typescript from vue-mq plugin: https://www.npmjs.com/package/vue-mq
 * Should to be a custom implementation.
 */

import json2mq from "json2mq"

// utils.js from vue-mq
function isArray(arg)
{
	return Object.prototype.toString.call(arg) === "[object Array]"
}

// helpers.js from vue-mq
function convertBreakpointsToMediaQueries(breakpoints)
{
	const keys = Object.keys(breakpoints)
	const values = keys.map(key => breakpoints[key])
	const breakpointValues = [0, ...values.slice(0, -1)]
	const mediaQueries = breakpointValues.reduce((sum, value, index) =>
	{
		const options = Object.assign(
			{
				minWidth: value
			},
			index < keys.length - 1 ? { maxWidth: breakpointValues[index + 1] - 1 } : {}
		)
		const mediaQuery = json2mq(options)
		return Object.assign(
			sum,
			{
				[keys[index]]: mediaQuery
			}
		)
	}, {})
	return mediaQueries
}

function transformValuesFromBreakpoints(breakpoints, values, currentBreakpoint)
{
	const findClosestValue = (currentBreakpoint) =>
	{
		if (values[currentBreakpoint] !== undefined) return values[currentBreakpoint]
		const index = breakpoints.findIndex(b => b === currentBreakpoint)
		const newBreakpoint = index !== -1 || index !== 0 ? breakpoints[index - 1] : null
		if (!newBreakpoint) return values[index]
		return values[newBreakpoint] !== undefined ? values[newBreakpoint] : findClosestValue(newBreakpoint)
	}
	return findClosestValue(currentBreakpoint)
}

function selectBreakpoints(breakpoints, currentBreakpoint)
{
	const index = breakpoints.findIndex(b => b === currentBreakpoint)
	return breakpoints.slice(index)
}

function subscribeToMediaQuery(mediaQuery, enter)
{
	const mql = window.matchMedia(mediaQuery)
	const cb = ({ matches }) =>
	{
		if (matches) enter()
	}
	mql.addListener(cb) // subscribing
	cb(mql) // initial trigger
}

// component.js from vue-mq
const mqComponent = {
	props: {
		mq: {
			required: true,
			type: [String, Array]
		}
	},
	computed: {
		plusModifier()
		{
			return !isArray(this.mq) && this.mq.slice(-1) === "+"
		},

		activeBreakpoints()
		{
			const breakpoints = Object.keys(this.$mqAvailableBreakpoints)
			const mq = this.plusModifier ? this.mq.slice(0, -1) : (isArray(this.mq) ? this.mq : [this.mq])
			return this.plusModifier
				? selectBreakpoints(breakpoints, mq)
				: mq
		}
	},
	render(h, props)
	{
		const shouldRenderChildren = this.activeBreakpoints.includes(this.$mq)
		return shouldRenderChildren ? h("div", this.$slots.default) : h()
	}
}

// index.js from vue-mq
const DEFAULT_BREAKPOINT = {
	mobilesmall: 375,
	mobile: 768,
	tablet: 1024,
	tablethori: 1200,
	desktop: Infinity
}

const install = function (Vue, { breakpoints = DEFAULT_BREAKPOINT, defaultBreakpoint = "mobile" } = {})
{
	let hasSetupListeners = false
	// Init reactive component
	const reactorComponent = new Vue({
		data: () => ({
			currentBreakpoint: defaultBreakpoint
		})
	})
	Vue.filter("mq", (currentBreakpoint, values) =>
	{
		return transformValuesFromBreakpoints(Object.keys(breakpoints), values, currentBreakpoint)
	})
	Vue.mixin({
		computed: {
			$mq()
			{
				return reactorComponent.currentBreakpoint
			},
			isMobileSmall()
			{
				return reactorComponent.currentBreakpoint === "mobilesmall"
			},
			isMobile()
			{
				return reactorComponent.currentBreakpoint === "mobile"
			},
			isTablet()
			{
				return reactorComponent.currentBreakpoint === "tablet"
			},
			isTabletHori()
			{
				return reactorComponent.currentBreakpoint === "tablethori"
			},
			isDesktop()
			{
				return reactorComponent.currentBreakpoint === "desktop"
			}
		},
		created()
		{
			if (this.$isServer) reactorComponent.currentBreakpoint = defaultBreakpoint
		},
		mounted()
		{
			if (!hasSetupListeners)
			{
				const mediaQueries = convertBreakpointsToMediaQueries(breakpoints)
				// setup listeners
				for (const key in mediaQueries)
				{
					const mediaQuery = mediaQueries[key]
					const enter = () =>
					{
						reactorComponent.currentBreakpoint = key
					}
					subscribeToMediaQuery(mediaQuery, enter)
				}
				hasSetupListeners = true
			}
		}
	})
	Vue.prototype.$mqAvailableBreakpoints = breakpoints
	Vue.component("MqLayout", mqComponent)
}

export default { install }
